module.exports = __webpack_public_path__ + "static/ball-cropped-ccf8b096744e1ab6b093c0aa75df98a9.jpg";